module.exports = __webpack_public_path__ + "static/scale-model-of-highpointe-park-in-columbia-missouri-d9f90c7ec9043da259b125aa059e4fae.png";